import { defineStore } from "pinia";

export const useDownloadingStore = defineStore("downloading", {
  state: () => {
    return { downloading: false, downloadSize: 0, downloadProgress: 0};
  },
});
